import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getList(params) {
  return request({
    url: URL.mdm.basicData.customerSource,
    method: 'get',
    params
  })
}

export function saveCustomerSource(data) {
  return request({
    url: URL.mdm.basicData.customerSource,
    method: 'post',
    data
  })
}

export function deleteCustomerSource(uuid) {
  return request({
    url: URL.mdm.basicData.customerSource + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
